import { gate } from 'hub-http/gates';
export const CRMRecordsEngagementSummary = gate('CRM:Records:EngagementSummary');